import styled from 'styled-components';
import { Typography } from '@libs/components';
import { FeeCorner } from 'src/assets';
type TooltipProps = {
  isEnd?: boolean;
};
export const StatWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  &:last-child {
    align-items: flex-end;
  }
  width: 100%;
  &:first-child {
    align-items: flex-start;
  }
`;
export const StatusBar = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  height: 0.6rem;
  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
  background-color: ${({ theme }) => theme.colors.borders.default};
  margin-bottom: 0.8rem;
`;
export const Body = styled.div`
  display: flex;
  flex-direction: column;
`;
export const Title = styled(Typography)`
  margin-bottom: 0.8rem;
`;
export const Container = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius.highM};
  background-color: ${({ theme }) => theme.colors.surface.default};
  box-shadow: ${({ theme }) => theme.shadows.sm};
  padding: 1.6rem 1.6rem 2.4rem;
  margin: 0 1.6rem 0;
  background-image: url(${FeeCorner});
  background-repeat: no-repeat;
  background-position-y: top;
  background-position-x: right;
  ${({ theme }) => theme.media.laptop`
             margin:0;
  `}
`;
export const RangeWrapper = styled.div`
  display: flex;
  gap: 0.4rem;
  margin-top: 4.5rem;
`;
export const DynamicBar = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.interactive.brandColor};
  height: 0.6rem;
  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};
`;
export const CircleCenter = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  width: 0.6rem;
  height: 0.6rem;
  border-radius: ${({ theme }) => theme.borderRadius.highest};
  background-color: ${({ theme }) => theme.colors.interactive.brandColor};
`;
export const Circle = styled.div`
  position: absolute;
  right: -0.7rem;
  width: 1.4rem;
  height: 1.4rem;
  border-radius: ${({ theme }) => theme.borderRadius.highest};
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(3px);
`;
export const Tooltip = styled.div<TooltipProps>`
  display: flex;
  justify-content: center;
  position: absolute;
  background-color: ${({ theme }) => theme.colors.interactive.brandColor};
  color: ${({ theme }) => theme.colors.surface.default};
  padding: 0.4rem 0.4rem 0;
  border-radius: ${({ theme }) => theme.borderRadius.low};
  white-space: nowrap;
  top: -3.2rem;
  right: ${({ isEnd }) => (isEnd ? '-0.5rem' : 'unset')};
  &::after {
    content: '';
    position: absolute;
    bottom: -0.3em;
    right: ${({ isEnd }) => (isEnd ? '0.3rem' : 'unset')};
    transform: rotate(45deg);
    width: 1rem;
    height: 1rem;
    background-color: ${({ theme }) => theme.colors.interactive.brandColor};
    border-bottom-right-radius: 0.2rem;
    z-index: -1;
    transition: left 0.05s ease-out;
  }
`;
export const Footer = styled.div`
  padding: 2.4rem 0.8rem 0;
`;
